import * as React from 'react';
import { observer } from 'mobx-react';
import { ExperienceResource } from '../../../Types';
import { T } from '../../../../../../../../../Translations';

export interface Props {
  resource: ExperienceResource;
}

const CompetencyOverview: React.FC<Props> = ({ resource }) => {
  switch (resource.payload.offeringType) {
    case 'coaching':
      return (
        <div className="text-xs">
          <T kind="Leadership Coaching experiences can address ..." />
        </div>
      );
    case 'epc':
    case 'aep':
    case 'group-coaching':
    case 'program-sequence':
      return <></>;
  }
};

export default observer(CompetencyOverview);
